import React, {FC} from 'react';

import {HandlerOf} from '../../../../libs/shared/helpers/src/react/reactHelpers';
import {MultipleGroupsDropdownBox} from '../../rules/ruleEditor/dropdowns/multipleGroupsDropdownBox';
import {DropdownGroup} from '../../rules/ruleEditor/dropdowns/multipleGroupsDropdownHelpers';
import {RuleConditionDefinition} from '../../rules/ruleParameterModel';

/*
 * Types.
 */

interface ConditionPickerProps {
  groups: ReadonlyArray<DropdownGroup<RuleConditionDefinition>>;
  onAddCondition: HandlerOf<RuleConditionDefinition>;
}

/*
 * Component.
 */

export const ConditionPicker: FC<ConditionPickerProps> = (props) => {
  const {groups, onAddCondition, children} = props;

  return (
    <MultipleGroupsDropdownBox
      groups={groups}
      selectedItems={[]}
      canSelectMultipleItems={false}
      onChange={(selectedValue: ReadonlyArray<RuleConditionDefinition>) => onAddCondition(selectedValue[0])}
      renderButton={() => children}
      shouldMergeGroupsWhenSearch
      hasBackground
    />
  );
};
